<template>
  <div class="body__wrapper" id="body__wrapper">
    <component :is="layout">
      <router-view></router-view>
    </component>
  </div>
</template>

<script>
  import Vue from 'vue';
  import vueHeadful from 'vue-headful';

  import EmptyLayout from "./Layouts/Main/EmptyLayout";
  import MainLayout from "./Layouts/Main/MainLayout";

  Vue.component('vue-headful', vueHeadful);

  export default {
    name: 'App',
    computed: {
      layout() {
        return ((this.$route.meta.layout || 'Empty') + 'Layout');
      },
    },
    components: {
      EmptyLayout,
      MainLayout
    },
  }
</script>

<style>
  @import "Assets/Helper.css";
</style>
